export default {
	vipBenefits: {
		salaryTitle: 'VIP वेतन',
		benefitsTitle: 'लाभ',
		yourVipProgress: 'आपकी VIP प्रगति',
		progressToVip: 'VIP {level} तक {percent}%',
		vipMax: 'अधिकतम स्तर प्राप्त',
		vipLevelBenefits: 'VIP स्तर और लाभ',
		betXpRule: '{amount} दांव = {xp}EXP',
		btnReceive: 'प्राप्त करें',
		btnJoinIn: 'शामिल हों',
		btnReceived: 'प्राप्त हुआ',
		btnExpired: 'समाप्त',
		btnNotSettled: 'निपटान नहीं हुआ',
		btnComingSoon: 'जल्द आ रहा है',
		btnViewMore: 'और देखें',
		btnContactNow: 'संपर्क करें',
		guestTitleLevelup: 'लेवल अप बोनस',
		guestTitleDaily: 'दैनिक वेतन',
		guestTitleWeekly: 'साप्ताहिक वेतन',
		guestTitleMonthly: 'मासिक वेतन',
		guestTitleCashback: 'कैशबैक',
		guestTitleRescue: 'रेस्क्यू बोनस',
		guestTitleEvents: 'VIP इवेंट',
		guestTitleSupport: 'VIP सहायता',
		guestDescLevelup: 'हर बार नया VIP स्तर पाने पर एकमुश्त बोनस पाएं।',
		guestDescDaily: 'आपका VIP स्तर बढ़ने पर दैनिक वेतन इनाम प्राप्त करें।',
		guestDescWeekly: 'आपका VIP स्तर बढ़ने पर साप्ताहिक वेतन इनाम प्राप्त करें।',
		guestDescMonthly: 'आपका VIP स्तर बढ़ने पर मासिक वेतन इनाम प्राप्त करें।',
		guestDescCashback: 'अपने गेम खर्च पर कैशबैक कमाएं।',
		guestDescRescue: 'वापसी में मदद के लिए रेस्क्यू बोनस पाएं।',
		guestDescEvents: 'उच्च VIP स्तर अधिक विशेष इवेंट इनाम अनलॉक करते हैं।',
		guestDescSupport: 'तेज़ सहायता के लिए समर्पित VIP सहायता।',
		comingSoonHint: 'लाभ जल्द आ रहा है, कृपया प्रतीक्षा करें',
		receiveSuccess: 'पुरस्कार प्राप्त हुआ',
		receiveFailed: 'पुरस्कार प्राप्त करने में विफल',
		typeUpgrade: 'लेवल अप बोनस',
		typeDailySalary: 'दैनिक वेतन',
		typeWeeklySalary: 'साप्ताहिक वेतन',
		typeMonthlySalary: 'मासिक वेतन',
		typeRebate: 'कैशबैक',
		typeRescue: 'रेस्क्यू बोनस',
		typeVipActivity: 'VIP इवेंट',
		typeVipService: 'VIP सहायता',
		tooltipRecharge: 'रिचार्ज {current}/{target}',
		tooltipBets: 'दांव {current}/{target}',
		progressRecharge: 'रिचार्ज',
		progressBets: 'दांव',
		descUpgradeBonus: 'VIP{level} अपग्रेड बोनस ×{count}',
		descDailySalary: 'VIP{level} दैनिक वेतन ×{count}',
		descWeeklySalary: 'VIP{level} साप्ताहिक वेतन ×{count}',
		descMonthlySalary: 'VIP{level} मासिक वेतन ×{count}',
		descUpgradeBonusPlain: 'VIP{level} अपग्रेड बोनस',
		descDailySalaryPlain: 'VIP{level} दैनिक वेतन',
		descWeeklySalaryPlain: 'VIP{level} साप्ताहिक वेतन',
		descMonthlySalaryPlain: 'VIP{level} मासिक वेतन',
		descRebate: 'VIP{level} गेम कैशबैक',
		descRescue: 'VIP{level} रेस्क्यू बोनस',
		descVipActivity: 'उच्च VIP स्तर अधिक विशेष इवेंट इनाम अनलॉक करते हैं।',
		descVipService: 'तेज़ सहायता के लिए समर्पित VIP सहायता।',
		allBenefits: 'सभी लाभ',
		vipClubTitle: 'VIP Club',
		more: 'अधिक',
		moreDesc: 'अधिक जानकारी के लिए कृपया हमारे प्रमोशन देखें।',
		promotions: 'प्रमोशन',
		highlightsTitle: '8 विशेष सुविधाएं',
		highlightSupport: 'विशेष VIP सहायता',
		highlightLevelup: 'लेवल अप बोनस',
		highlightSalary: 'VIP वेतन',
		highlightRescue: 'VIP बचाव बोनस',
		highlightGifts: 'विशेष\nVIP उपहार',
		highlightEvents: 'VIP इवेंट',
		highlightService: 'समर्पित\nVIP सेवा',
		highlightWallet: 'VIP\nक्रेडिट वॉलेट',
		currentLevel: 'वर्तमान स्तर',
		keepPlayingReach: 'पहुंचने के लिए खेलते रहें',
		higherLevelRewards: 'जितना ऊंचा स्तर, उतने बड़े पुरस्कार',
		levelUpUnlock: 'विशेष लाभ अनलॉक करने और प्रीमियम अनुभव का आनंद लेने के लिए अपना स्तर बढ़ाएं।',
		yourVipBenefits: 'आपके VIP लाभ',
		viewVipLevels: 'VIP स्तर देखें',
		exclusiveBenefitsTitle: 'आपके विशेष लाभ',
		tipExclusiveRewards: 'विशेष पुरस्कार',
		tipHigherRakeback: 'अधिक रेकबैक',
		tipPrioritySupport: 'प्राथमिकता सहायता',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'स्तर',
		tableRequiredXp: 'आवश्यक EXP',
		tableLevelUpBonus: 'लेवल अप बोनस',
		tableDailyRakeback: 'दैनिक रेकबैक',
		tableWeeklyLossback: 'साप्ताहिक हानि वापसी',
		signIn: 'साइन इन',
		vipClubDefaultDesc: 'अभी हमारे VIP Club से जुड़ें और उपहार, गिवअवे और शानदार फीचर्स पाने के लिए तैयार हो जाएं।',
	},
};
